export enum FilterToolEnum {
  PRESET_STATIC = 'PRESET_STATIC',
  CHECKBOX = 'CHECKBOX',
  SLIDER = 'SLIDER',
  SWITCH = 'SWITCH',
  DATE_PICKER = 'DATE_PICKER',
  DROPDOWN_LIST = 'DROPDOWN_LIST',
  DATE_INTERVAL = 'DATE_INTERVAL',
  TEXT = 'TEXT',
}
